export default "__VITE_ASSET__58e00584__"